import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";

// --- Core Page Imports (Absolute paths) ---
import Homepage from "pages/homepage";
import Gallery from "pages/gallery";
import Testimonials from "pages/testimonials";
import About from "pages/about";
import Services from "pages/services";
import Contact from "pages/contact";
import NotFound from "pages/NotFound";

// --- CORRECTED: Individual Service Page Imports (Now using absolute paths) ---
import EventDecorAndStylingPage from "pages/ServicePages/EventDecorAndStylingPage";
import CorporateEventsPage from "pages/ServicePages/CorporateEventsPage";
import PrivateCelebrationsPage from "pages/ServicePages/PrivateCelebrationsPage";
import PremiumRentalsAndLogisticsPage from "pages/ServicePages/PremiumRentalsAndLogisticsPage";
import VipSocialsAndLifestyleEventsPage from "pages/ServicePages/VipSocialsAndLifestyleEventsPage";


const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <RouterRoutes>
          {/* --- Core Routes --- */}
          <Route path="/" element={<Homepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* --- Individual Service Routes (Paths are unchanged) --- */}
          <Route path="/services/event-decor-and-styling" element={<EventDecorAndStylingPage />} />
          <Route path="/services/corporate-events" element={<CorporateEventsPage />} />
          <Route path="/services/private-celebrations" element={<PrivateCelebrationsPage />} />
          <Route path="/services/premium-rentals-and-logistics" element={<PremiumRentalsAndLogisticsPage />} />
          <Route path="/services/vip-socials-and-lifestyle-events" element={<VipSocialsAndLifestyleEventsPage />} />

          {/* --- Catch-all 404 Route --- */}
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;